import { render, staticRenderFns } from "./IssueStatus.vue?vue&type=template&id=02278d8d&scoped=true"
import script from "./IssueStatus.vue?vue&type=script&lang=js"
export * from "./IssueStatus.vue?vue&type=script&lang=js"
import style0 from "./IssueStatus.vue?vue&type=style&index=0&id=02278d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02278d8d",
  null
  
)

export default component.exports